module.exports = __webpack_public_path__ + "static/media/country_fo.a6662b31.webp";